import React, { useEffect, useRef, useState } from "react"
import useGetDeviceType from "../../hooks/useGetDeviceType"
import edit from "../../assets/images/edit.svg"
import edit1 from "../../assets/images/edit-form.svg"
import ToggleSwitch from "../ToggleSwitch"
import styles from "./Table.module.scss"
import CommonMenu from "./components/CommonMenu"
import chat_svg from "../../assets/images/chat.svg"
import AssignedToMenu from "./components/AssignedToMenu"
import Delete_order from "../../assets/images/Delete_order.svg"
import delete_icon from "../../assets/images/delete-ticket.svg"
import ToolTip from "../ToolTip/ToolTip"
import ViewMore from "./components/ViewMore"
import verified from "../../assets/images/verified.svg"
import reject_info_icon from "../../assets/images/red_info_icon.svg"
import verified_check from "../../assets/images/verified_check.svg"
import download from "../../assets/images/download.svg"
import cancel_icon from "../../assets/images/cancel_icon.svg"
import { ButtonMedium } from "../Button"
import TicketAge from "./components/TicketAge"
import project_dropped from "../../assets/images/project_dropped.svg"
import LinearProgressBar from "../LinearProgressBar"
import HistoryFile from "./components/HistoryFile"
import linked_ticket from "../../assets/images/linked_icon.svg"
import { extractTextFromElement } from "../../utils/utils"
import InputTag from "../Input/InputTag"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import {
    setIsNavigated,
    setSitesCurrentRuleValue,
    setSitesDisplayValues,
} from "../../pages/Operations/features/Survey/SurveySlice"
import {
    setSitesCurrentRuleValue as setProjectSitesCurrentRuleValue,
    setSitesDisplayValues as setProjectSitesDisplayValues,
    setIsNavigated as setProjectIsNavigated,
    setQueryByIds,
} from "../../pages/Projects/ProjectSlice"
import {
    setSitesCurrentRuleValue as setLogisticsSitesCurrentRuleValue,
    setSitesDisplayValues as setLogisticsSitesDisplayValues,
    setIsNavigated as setLogisticsIsNavigated,
} from "../../pages/Logistics/LogisticsSlice"
import {
    setSitesCurrentRuleValue as setDemolitionSitesCurrentRuleValue,
    setSitesDisplayValues as setDemolitionSitesDisplayValues,
} from "../../pages/Operations/OperationSlice"
import { setIsNavigated as setDemolitionIsNavigated } from "../../pages/Operations/features/Demolition/DemolitionSlice"

const useTable = (rowData: any, excludeIndexes: any) => {
    const [tableRowData, setTableRowData] = useState(rowData)
    const [sortType, setSortType] = useState<any>({})
    const { deviceType } = useGetDeviceType()
    const [showTooltip, setShowTooltip] = useState(false)
    const [reason, setReason] = useState("")
    const tooltipRef = useRef<HTMLDivElement>(null)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    // Close the tooltip if clicking outside
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
                setShowTooltip(false)
            }
        }
        document.addEventListener("mousedown", handleClickOutside)
        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [])

    const handleRejectClick = () => {
        setShowTooltip(true)
    }

    const handleSubmit = () => {
        setReason("")
        setShowTooltip(false)
    }
    const handleRedirect = (
        site_id: number,
        name: string,
        site_name: string,
        module?: string,
        linkedIds?: number[]
    ) => {
        if (name === "Survey") {
            dispatch(
                setSitesDisplayValues([
                    {
                        id: site_id,
                        name: site_name,
                    },
                ])
            )
            dispatch(
                setSitesCurrentRuleValue([
                    {
                        id: site_id,
                        title: site_name,
                    },
                ])
            )
            dispatch(setIsNavigated(true))

            navigate("/Survey", {
                state: {
                    redirectedSiteId: site_id,
                    site_name: site_name,
                },
            })
        } else if (name === "Projects") {
            if (module === "accounts") {
                dispatch(setQueryByIds(linkedIds))
            } else {
                dispatch(
                    setProjectSitesDisplayValues([
                        {
                            id: site_id,
                            name: site_name,
                        },
                    ])
                )
                dispatch(
                    setProjectSitesCurrentRuleValue([
                        {
                            id: site_id,
                            title: site_name,
                        },
                    ])
                )
            }
            dispatch(setProjectIsNavigated(true))
            navigate("/Projects", {
                state: {
                    redirectedSiteId: site_id,
                    site_name: site_name,
                },
            })
        } else if (name === "Logistics") {
            dispatch(
                setLogisticsSitesDisplayValues([
                    {
                        id: site_id,
                        name: site_name,
                    },
                ])
            )
            dispatch(
                setLogisticsSitesCurrentRuleValue([
                    {
                        id: site_id,
                        title: site_name,
                    },
                ])
            )
            dispatch(setLogisticsIsNavigated(true))
            navigate("/Logistics", {
                state: {
                    redirectedSiteId: site_id,
                    site_name: site_name,
                },
            })
        } else if (name === "Demolition") {
            dispatch(
                setDemolitionSitesDisplayValues([
                    {
                        id: site_id,
                        name: site_name,
                    },
                ])
            )
            dispatch(
                setDemolitionSitesCurrentRuleValue([
                    {
                        id: site_id,
                        title: site_name,
                    },
                ])
            )
            dispatch(setDemolitionIsNavigated(true))
            navigate("/Demolition", {
                state: {
                    redirectedSiteId: site_id,
                    site_name: site_name,
                },
            })
        }
    }
    const actionsHandler = (actions: any, index: number, arr: any) => {
        if (actions?.length === 0) return

        const output = actions?.map((data: any, idx: number) => {
            switch (data?.type) {
                /* Add custom cases here */
                case "edit":
                    return arr?.ticketStatus !== undefined &&
                        (arr?.ticketStatus === "Completed" || arr?.ticketStatus === "Dropped") ? null : (
                        <img
                            src={edit}
                            alt="edit"
                            style={data?.allowed === false ? { cursor: "not-allowed" } : {}}
                            onClick={() => {
                                if (typeof rowData?.[index]?.active === "boolean") {
                                    if (data?.allowed && rowData?.[index]?.active) data?.handler(index)
                                } else {
                                    if (data?.allowed) data?.handler(index)
                                }
                            }}
                        />
                    )

                case "edit-1":
                    return arr?.ticketStatus !== undefined &&
                        (arr?.ticketStatus === "Completed" ||
                            arr?.ticketStatus === "Dropped") ? null : !excludeIndexes?.includes(index) ? (
                        <img
                            src={edit1}
                            alt="edit"
                            onClick={() => {
                                if (typeof rowData?.[index]?.active === "boolean") {
                                    if (data?.allowed && rowData?.[index]?.active) data?.handler(index)
                                } else {
                                    if (data?.allowed) data?.handler(index)
                                }
                            }}
                        />
                    ) : (
                        <></>
                    )

                case "delete":
                    return arr?.is_associated === true &&
                        arr?.is_associated !== undefined ? null : arr?.ticketStatus !== undefined &&
                      (arr?.ticketStatus === "Completed" ||
                          arr?.ticketStatus === "Dropped") ? null : !excludeIndexes?.includes(index) ? (
                        <img
                            src={delete_icon}
                            style={data?.allowed === false ? { cursor: "not-allowed" } : {}}
                            alt="delete_icon"
                            onClick={() => {
                                if (data?.allowed) data?.handler(index)
                            }}
                        />
                    ) : (
                        <></>
                    )
                case "deleteTag":
                    return arr?.ticketStatus === "Completed" || arr?.["Status"]?.value === "Completed" ||
                        arr?.ticketStatus === "Dropped" ? null : !excludeIndexes?.includes(index) ? (
                        <img
                            src={delete_icon}
                            style={
                                data?.allowed === false || arr.Status?.value === "Inactive"
                                    ? { cursor: "not-allowed" }
                                    : {}
                            }
                            alt="delete_icon"
                            onClick={() => {
                                if (data?.allowed && arr.Status?.value !== "Inactive") data?.handler(index)
                            }}
                        />
                    ) : (
                        <></>
                    )

                case "Comments":
                    return arr?.ticketStatus !== undefined &&
                        arr.is_project_module &&
                        arr?.ticketStatus === "Dropped" ? null : (
                        <img
                            style={data?.allowed === false ? { cursor: "not-allowed" } : {}}
                            src={chat_svg}
                            alt="comments"
                            onClick={() => {
                                if (data?.allowed) data?.handler(index)
                            }}
                        />
                    )

                case "files":
                    return arr?.Remarks?.file_url === null ? (
                        <span> - </span>
                    ) : (
                        <span
                            className={styles.underline}
                            onClick={() => {
                                data?.handler(index)
                            }}>
                            View
                        </span>
                    )

                case "purchase_files":
                    return arr["Uploaded On"]?.file?.is_excel === true ? (
                        <a
                            href={arr["Uploaded On"].file?.urls?.download}
                            download
                            target="_blank"
                            rel="noreferrer"
                            className={styles.underline}>
                            View
                        </a>
                    ) : arr["Uploaded On"].file?.urls?.view === null ? (
                        "-"
                    ) : (
                        <span
                            className={styles.underline}
                            onClick={() => {
                                data?.handler(index)
                            }}>
                            View
                        </span>
                    )
                case "toggle":
                    return (
                        <ToggleSwitch
                            key={0}
                            disabled={false}
                            cursor={data?.allowed === false ? "not-allowed" : "pointer"}
                            checked={rowData?.[index]?.active}
                            toggleSwitch={() => {
                                if (!data?.allowed) return
                                data?.handler(index)
                            }}
                            tooltipContent={rowData?.[index]?.active && data?.tooltipContent}
                        />
                    )

                case "download": {
                    return (
                        <a href={rowData?.[index]?.link?.urls?.download} download target="_blank">
                            <img src={download} alt="download" />
                        </a>
                    )
                }
                default:
                    return <></>
            }
        })

        return output
    }
    const actionsDeleteHandler = (actions: any, index: number, arr: any) => {
        if (actions?.length === 0) return

        const output = actions?.map((data: any, idx: number) => {
            switch (data?.type) {
                case "delete":
                    return arr?.Remarks?.status !== undefined ? (
                        arr?.Remarks?.show_add_button && (
                            <img
                                src={data?.icon !== undefined ? data?.icon : Delete_order}
                                alt="Delete_order"
                                onClick={() => {
                                    data?.handler(index)
                                }}
                            />
                        )
                    ) : (
                        <img
                            src={data?.icon !== undefined ? data?.icon : Delete_order}
                            alt="Delete_order"
                            onClick={() => {
                                data?.handler(index)
                            }}
                        />
                    )
                case "verified":
                    return arr?.Remarks?.is_verified === 1 ? (
                        <img src={verified} alt="verified" />
                    ) : arr?.Remarks?.is_verified === -1 ? (
                        <img src={cancel_icon} alt="rejected" />
                    ) : null
                case "verifiedFinance":
                    return arr?.Remarks?.is_verified === 1 ? (
                        <span style={{ fontWeight: 500, color: "#00B603" }}>Verified</span>
                    ) : arr?.Remarks?.is_verified === -1 ? (
                        <>
                            <span style={{ fontWeight: 500, color: "#F94054" }}>Rejected</span>
                            {arr?.Remarks?.reject_reason !== undefined || arr?.Remarks?.reject_reason !== null ? (
                                <ToolTip
                                    click={true}
                                    trigger={
                                        <div>
                                            <img
                                                src={reject_info_icon}
                                                alt="inforIcon"
                                                style={{ marginTop: 5, width: 15 }}
                                            />
                                        </div>
                                    }
                                    data={<div style={{ fontWeight: 500 }}>{arr?.Remarks?.reject_reason}</div>}
                                    width="185px"
                                    spaceFromRight="35%"
                                    spaceFromLeft="unset"
                                />
                            ) : (
                                ""
                            )}
                        </>
                    ) : null
                case "verifyDetail":
                    return arr?.Remarks?.show_button === true && arr?.Remarks?.is_verified === 0 ? (
                        <div>
                            <ButtonMedium
                                style={{
                                    height: "18px",
                                    width: "47px",
                                    fontSize: "10px",
                                    color: "#12D377",
                                    borderColor: "#12D377",
                                }}
                                onClick={() => {
                                    data?.handler(index, 1)
                                }}>
                                Verify
                            </ButtonMedium>
                            <ButtonMedium
                                style={{ height: "18px", width: "47px", fontSize: "10px", marginLeft: 10 }}
                                onClick={() => {
                                    data?.rejectHandler(index, -1)
                                }}>
                                Reject
                            </ButtonMedium>
                        </div>
                    ) : null
                case "verifyReject":
                    return arr?.Remarks?.show_button === true && arr?.Remarks?.is_verified === 0 ? (
                        <div>
                            <ButtonMedium
                                style={{
                                    height: "18px",
                                    width: "47px",
                                    fontSize: "10px",
                                    color: "#12D377",
                                    borderColor: "#12D377",
                                }}
                                onClick={() => {
                                    data?.handler(index, 1)
                                }}>
                                Verify
                            </ButtonMedium>
                            <div className={styles.reject_container}>
                                <ButtonMedium
                                    style={{
                                        height: "18px",
                                        width: "47px",
                                        fontSize: "10px",
                                        marginLeft: 10,
                                        position: "absolute",
                                        bottom: 10,
                                        left: 10,
                                    }}
                                    onClick={() => {
                                        handleRejectClick()
                                    }}>
                                    Reject
                                </ButtonMedium>
                                {showTooltip && (
                                    <div ref={tooltipRef} className={styles.reject_modal}>
                                        <div className="flex">
                                            <InputTag
                                                type="text"
                                                value={reason}
                                                onChange={e => setReason(e.target.value)}
                                                placeholder="Enter reason..."
                                            />
                                            <img
                                                src={verified_check}
                                                alt="verified"
                                                onClick={() => {
                                                    data?.subHandler(index, -1, reason)
                                                    handleSubmit()
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : null
                default:
                    return <></>
            }
        })
        return output
    }
    const typeHandler = (type: string, data: any) => {
        switch (type) {
            case "underline":
                return <span className={styles?.underline}>{data?.value}</span>
            case "user":
                return data?.isEditable && data?.value ? (
                    <AssignedToMenu
                        submodule_id={data?.sub_module}
                        module_id={data?.module_id}
                        detail={data?.detail}
                        user_info={data?.user_info}
                        name={data?.value}
                        page={data?.page}
                        per_page={data?.per_page}
                        allowed={data?.allowed}
                    />
                ) : (
                    <div className={styles.user_initial_container}>
                        <div style={{ backgroundColor: `${data?.user?.colour}` }} className={styles.user_initial}>
                            {data?.user?.initial}
                        </div>
                        <span className={styles.user_name}>
                            {data?.value?.length > 0 &&
                                (data?.value?.length < 8 ? data?.value : data?.value?.substring(0, 8) + "...")}
                        </span>
                    </div>
                )
            case "status":
                return data?.popup === true ? (
                    <span
                        className={
                            data?.rejected_status === true
                                ? `d-inline ${styles.dropped} ${styles.rejected_underline}`
                                : `d-inline ${styles.underline} ${styles.dropped} `
                        }
                        onClick={() => data?.onHoldClick()}
                        style={{
                            width: data?.width !== undefined ? data?.width : "",
                            height: data?.height !== undefined ? data?.height : "",
                        }}>
                        {" "}
                        {data.value}
                    </span>
                ) : data?.show_progress ? (
                    <div className={styles.progress_container}>
                        <span className={styles.status_text}>{data.value}</span>
                        <div className={styles.progress_bar}>
                            <LinearProgressBar
                                backgrounColor={data?.progress > 75 ? "#D0F6E4" : "#E8E8EC"}
                                progressColor={data?.progress > 75 ? "#12D377" : "#70758D"}
                                value={data?.progress?.toFixed(2)}
                                type={2}
                            />
                        </div>
                    </div>
                ) : (
                    <span
                        className={data.status_color !== null ? styles.status : ""}
                        style={{
                            background: `${data.status_color}`,
                            color: data.text_color,
                            width: data?.width !== undefined ? data?.width : "",
                            height: data?.height !== undefined ? data?.height : "",
                        }}>
                        {data.value}{" "}
                    </span>
                )
            case "displayId":
                return (
                    <span
                        className={styles?.display_id}
                        onClick={(event: any) => data?.onIdClick(event)}
                        style={
                            data?.drop_flag === 1
                                ? {
                                      display: "flex",
                                      alignItems: "center",
                                      /* justifyContent: 'space-between', */ width: `65%`,
                                      textDecoration: data?.hide_hyperlink ? "none" : "underline",
                                  }
                                : { textDecoration: data?.hide_hyperlink ? "none" : "underline" }
                        }>
                        {data?.value}
                        {data?.drop_flag === 1 ? (
                            <img id="project_drop_icon" src={project_dropped} alt="dropped" />
                        ) : data.is_read === false ? (
                            <span className={styles.table_col_highlighted__unread}></span>
                        ) : (
                            <></>
                        )}
                    </span>
                )
            case "profit_share":
                return (
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ width: "100px" }}>{data?.value?.profit_type}</div>{" "}
                        <div style={{ marginLeft: 5, width: "50px" }}>{data?.value?.profit_amt}</div>
                    </div>
                )
            case "location":
                return (
                    <span>
                        {data.value.city}
                        {data.value.state !== null ? "," : "-"} {data.value.state}
                    </span>
                )
            case "charger_details":
                return data?.value?.chargers?.total > 0 ? (
                    <CommonMenu
                        detail={data?.value}
                        type={"charger_details"}
                        show_charger_icon={data?.show_charger_icon}
                        isChargerSku={data?.isChargerSku}
                        module={data?.module}
                    />
                ) : (
                    "-"
                )
            case "scope_menu":
                return <CommonMenu detail={data?.value} type={"scope_menu"} />
            case "view_more":
                return <ViewMore data={data?.value} utr_num={data?.utr_num} heading={data?.heading} />
            case "ticket_age":
                return (
                    <TicketAge
                        detail={data?.value}
                        setAgeValue={data?.setAgeValue}
                        ageValue={data?.ageValue}
                        show_age_popup={data?.age_popup}
                    />
                )
            case "commentsView": {
                if (!data?.value) return "-"
                const truncatedText = `${data?.value.slice(0, 45)}${
                    data?.isRemarksMore ? `...` : data?.value.length > 45 ? "..." : ""
                }`
                const handleMoreClick = () => {
                    if (data?.isRemarksMore) {
                        data?.handleComments(data?.doc_id)
                        data?.setIsRemarksMore(data?.isRemarksMore)
                    } else if (data?.value?.length > 45) {
                        data?.showRemarksModal()
                        data?.setCompleteRemarksText(data?.value)
                    }
                }
                return (
                    <div>
                        {truncatedText}
                        {(data?.isRemarksMore || data?.value.length > 45) && (
                            <span className={styles?.underline} style={{ paddingLeft: 4 }} onClick={handleMoreClick}>
                                More
                            </span>
                        )}
                    </div>
                )
            }
            case "created-on":
                return <HistoryFile metadata={data?.metadata} value={data?.value} dataValue={data?.dataValue} />
            default:
                return data?.truncateText &&
                    [typeof data?.value === "string" ? data.value : extractTextFromElement(data.value)]?.toString()
                        ?.length > 23 ? (
                    <ToolTip
                        containerClass={styles.tooltip_container}
                        trigger={
                            <span style={{ whiteSpace: "break-spaces" }} className={styles.truncated_text}>
                                {data?.value !== null && data?.value !== undefined && data?.value !== ""
                                    ? data?.value
                                    : "-"}
                            </span>
                        }
                        data={data.value}
                        width={data?.tooltipWidth ? data?.tooltipWidth : "170px"}
                        tooltipPadding="8px"
                        spaceFromLeft="40px"
                    />
                ) : (
                    <span
                        style={{
                            whiteSpace: "break-spaces",
                            color: data?.textColor ? data?.textColor : "",
                            width: data?.value ? "100%" : "auto",
                        }}>
                        {data?.value !== null && data?.value !== undefined && data?.value !== "" && data?.value}
                    </span>
                )
        }
    }
    const tooltipTriggerTypeHandler = (data: any) => {
        switch (data?.type) {
            case "location":
                return data?.trigger ? (
                    <ToolTip
                        click={true}
                        trigger={<div className={styles?.location_trigger}>{data?.trigger}</div>}
                        data={
                            <div className={styles?.locations_tooltip}>
                                <div className={styles?.location_container}>
                                    <div className={`${styles?.location_header} ${styles?.location_section_1}`}>
                                        City
                                    </div>
                                    <div className={`${styles?.location_header} ${styles?.location_section_2}`}>
                                        State
                                    </div>
                                </div>
                                {data?.locations?.map((location: any, index: number) => {
                                    return (
                                        <div className={styles?.location_container} key={index}>
                                            <div className={`${styles?.location_name} ${styles?.location_section_1}`}>
                                                {location?.city}
                                            </div>
                                            <div className={`${styles?.location_name} ${styles?.location_section_2}`}>
                                                {location?.state}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        }
                        width="155px"
                    />
                ) : (
                    <></>
                )

            case "services":
                return data?.trigger ? (
                    <ToolTip
                        click={true}
                        trigger={<div className={styles?.location_trigger}>{data?.trigger}</div>}
                        data={
                            <div className={styles?.locations_tooltip}>
                                {data?.services?.map((category: any, index: number) => {
                                    return (
                                        <div className={styles?.location_container} key={index}>
                                            <div className={`${styles?.location_name} ${styles?.location_section_1}`}>
                                                {category?.category_name}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        }
                        width="155px"
                    />
                ) : (
                    <></>
                )

            case "poc-details": {
                return data?.trigger ? (
                    <ToolTip
                        click={true}
                        trigger={<div className={styles?.poc_trigger}>{data?.trigger}</div>}
                        data={
                            <div className={styles?.poc_tooltip}>
                                <div className={styles?.poc_container}>
                                    <div className={styles?.poc_header}>Phone</div>
                                    <div className={styles?.poc_header}>E-Mail</div>
                                </div>
                                <div className={styles?.poc_container}>
                                    <div className={styles?.poc_data}>{data?.detail?.phone || ""}</div>
                                    <div className={styles?.poc_data}>{data?.detail?.email || ""}</div>
                                </div>
                            </div>
                        }
                        width="200px"
                    />
                ) : (
                    <></>
                )
            }
            case "linked-projects": {
                return data?.trigger ? (
                    <ToolTip
                        click={true}
                        zIndex={999}
                        trigger={
                            <div className={`${styles?.poc_trigger} d-flex align-items-center`}>
                                {data?.trigger} <img src={linked_ticket} alt="linked_ticket" className="ml-6" />
                            </div>
                        }
                        data={
                            <div>
                                <div className="pt-12 pl-12 weight-500 text-left" style={{ color: "#FD7C62" }}>
                                    Linked Tickets
                                </div>
                                {data?.linkedData?.map((item: any, index: number) => {
                                    return (
                                        <div className={`${styles?.poc_tooltip} w-90`}>
                                            <div className={styles?.poc_container}>
                                                <div className={`${styles?.poc_header} text-left`}>{item?.name}</div>
                                            </div>
                                            <div className={styles?.poc_container}>
                                                <div
                                                    className={
                                                        item?.count > 0
                                                            ? `${styles?.poc_data} ${styles.underline}`
                                                            : `${styles?.poc_data} `
                                                    }
                                                    onClick={() =>
                                                        item?.name &&
                                                        item?.count > 0 &&
                                                        handleRedirect(
                                                            data?.site_id,
                                                            data?.module === "accounts" ? "Projects" : item?.name,
                                                            data?.site_name,
                                                            data?.module,
                                                            item?.linkedIds
                                                        )
                                                    }>
                                                    {item?.count || "-"}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        }
                        width="200px"
                    />
                ) : (
                    <></>
                )
            }
        }
        return <></>
    }

    const handleSort = (key: string) => {
        const newSortType = sortType[key] === "DSC" ? "ASC" : "DSC"

        setSortType((prev: any) => ({
            ...prev,
            [key]: newSortType,
        }))

        const sortedData = [...tableRowData]

        sortedData.sort((a, b) => {
            const aValue = typeof a[key]?.value === "object" ? a[key]?.value?.props?.children : a[key]?.value
            const bValue = typeof b[key]?.value === "object" ? b[key]?.value?.props?.children : b[key]?.value

            if (key === "Added On") {
                const aDate = new Date(aValue)
                const bDate = new Date(bValue)
                return newSortType === "ASC" ? aDate.getTime() - bDate.getTime() : bDate.getTime() - aDate.getTime()
            }

            if (typeof aValue === "string" && typeof bValue === "string") {
                return newSortType === "ASC" ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue)
            }

            return newSortType === "ASC" ? aValue - bValue : bValue - aValue
        })

        setTableRowData(sortedData)
    }

    useEffect(() => {
        if (rowData?.length) {
            setTableRowData(rowData)
        } else setTableRowData([])
    }, [rowData])

    return {
        sortType,
        tableRowData,
        deviceType,
        actionsHandler,
        typeHandler,
        tooltipTriggerTypeHandler,
        actionsDeleteHandler,
        handleSort,
    }
}

export default useTable
